import { FilterPeriodType } from '../../models';

const defaultOptions = [
  {
    value: FilterPeriodType.Yesterday,
    label: 'Yesterday',
  },
  {
    value: FilterPeriodType.Last7,
    label: 'Last 7 days',
  },
  {
    value: FilterPeriodType.Last30,
    label: 'Last 30 days',
  },
  {
    value: FilterPeriodType.CurrentMonth,
    label: 'Current month',
  },
  {
    value: FilterPeriodType.PreviousMonth,
    label: 'Previous month',
  },
  {
    value: FilterPeriodType.Period,
    label: 'Period',
  },
];

export const periodOptions = [
  {
    value: FilterPeriodType.AllTime,
    label: 'All items',
  },
  {
    value: FilterPeriodType.Today,
    label: 'Today',
  },
  ...defaultOptions,
];

export const hostsPeriodOptions = [
  {
    value: FilterPeriodType.AllTime,
    label: 'All items',
  },
  {
    value: FilterPeriodType.Today,
    label: 'Today',
  },
  ...defaultOptions,
];

export const trendsPeriodOptions = [
  {
    value: FilterPeriodType.Last3,
    label: 'Last 3 days',
  },
  {
    value: FilterPeriodType.Last7,
    label: 'Last 7 days',
  },
  {
    value: FilterPeriodType.Last30,
    label: 'Last 30 days',
  },
  {
    value: FilterPeriodType.Last90,
    label: 'Last 90 days',
  },
  {
    value: FilterPeriodType.Period,
    label: 'Period',
  },
];

export const ltvPeriodOptions = [
  {
    value: FilterPeriodType.AllTime,
    label: 'All time',
  },
  {
    value: FilterPeriodType.Last30,
    label: 'Last 30 days',
  },
  {
    value: FilterPeriodType.Last90,
    label: 'Last 90 days',
  },
  {
    value: FilterPeriodType.Last180,
    label: 'Last 180 days',
  },
  {
    value: FilterPeriodType.LastYear,
    label: 'Last Year',
  },
  {
    value: FilterPeriodType.Period,
    label: 'Period',
  },
];
